import React from 'react';

const TotalCertificationTr = ({ totals = {} }) => {
  const { creditsTotal } = totals;

  return (
    <tr className="summary-tr">
      <td className="txt-table-center">-</td>
      <td className="txt-table-center">
        <span style={{ fontWeight: 'bold' }}>Crediti totali:</span>{' '}
        {creditsTotal}
      </td>
    </tr>
  );
};

export default TotalCertificationTr;
